export const EP_GET_ALL_PRODUCT_TYPES = 
{
    path:"productType/getAllProductTypes",
    method:"GET"
};

export const EP_CREATE_PRODUCT_TYPE = 
{
    path:"productType/createProductType",
    method:"POST",
    requestBody: {
      "name": "abc"
    }
};

export const EP_DELETE_PRODUCT_TYPE = 
{
    path:"productType/deleteProductType",
    method:"DELETE",
    requestBody:{
        "_id": ""
      }
};

export const EP_UPDATE_PRODUCT_TYPE = 
{
    path:"productType/updateProductType",
    method:"PATCH",
    requestBody: {
        "name": "Jhon",
        "_id": ""
      }
};

export const EP_SEARCH_PRODUCT_TYPE = 
{
    path:"productType/searchProductType",
    method:"GET",
    params: {
        _id : "0"
    }
};
